import { ProductUnitCode } from '../enums/productUnitCode'

// Keyed by the UN/ECE code, which stays stable while the displayed abbreviation may change
export const productUnitCodeToTranslationKey: Record<ProductUnitCode, string> = {
  [ProductUnitCode.Bag]: 'products.units.full_name.bag',
  [ProductUnitCode.Bottle]: 'products.units.full_name.bottle',
  [ProductUnitCode.Carton]: 'products.units.full_name.carton',
  [ProductUnitCode.Centimeter]: 'products.units.full_name.centimeter',
  [ProductUnitCode.CubicMeter]: 'products.units.full_name.cubic_meter',
  [ProductUnitCode.Day]: 'products.units.full_name.day',
  [ProductUnitCode.Hour]: 'products.units.full_name.hour',
  [ProductUnitCode.Kilogram]: 'products.units.full_name.kilogram',
  [ProductUnitCode.Kilometer]: 'products.units.full_name.kilometer',
  [ProductUnitCode.Litre]: 'products.units.full_name.litre',
  [ProductUnitCode.Lot]: 'products.units.full_name.lot',
  [ProductUnitCode.LumpSum]: 'products.units.full_name.lump_sum',
  [ProductUnitCode.Meter]: 'products.units.full_name.meter',
  [ProductUnitCode.Month]: 'products.units.full_name.month',
  [ProductUnitCode.Pack]: 'products.units.full_name.pack',
  [ProductUnitCode.Pallet]: 'products.units.full_name.pallet',
  [ProductUnitCode.Piece]: 'products.units.full_name.piece',
  [ProductUnitCode.SquareMeter]: 'products.units.full_name.square_meter',
  [ProductUnitCode.Tonne]: 'products.units.full_name.tonne',
}
